import { Divider } from '@withjoy/joykit';
import { GeneralEventScheduleDataDay } from '../schedule.types';
import { ConfirmationDialogMode } from './ConfirmationDialog';
import { DayGroup } from './DayGroup';
import { EventRow } from './EventRow';
import React from 'react';
import { useTranslation } from '@shared/core';

type TbaSectionProps = {
  // Remove dates from TBA items
  day: Omit<GeneralEventScheduleDataDay['items'][number], 'startTimeISO8601TZ' | 'endTimeISO8601TZ'>[];
  isActive: boolean;
  setIsActive: (state: boolean) => void;
  onEditEvent: (eventId: string) => void; // Callback for editing an event
  onAddClick: () => void;
  setConfirmationType: (type: ConfirmationDialogMode | null) => void;
  setDeleteId: (id: string) => void;
};

export const TbaRow = (props: TbaSectionProps) => {
  const { day, onEditEvent, onAddClick, setConfirmationType, setDeleteId } = props;
  const { tq } = useTranslation('generalEventScheduleEditor');

  return (
    <DayGroup
      title={tq`Date To Be Announced`}
      onAddClick={onAddClick}
    >
      {day.map((event, index) => {
        const showDivider = index !== day.length - 1;

        return (
          <>
            <EventRow
              onEditClick={() => {
                onEditEvent(event.id);
              }}
              key={event.id}
              isPublic={true}
              title={event.name}
              subtitle={'TBA'}
              onDeleteClick={() => {
                setConfirmationType('delete');
                setDeleteId(event.id);
              }}
            ></EventRow>
            {showDivider && <Divider />}
          </>
        );
      })}
    </DayGroup>
  );
};

type DayToggleProps = {
  day: GeneralEventScheduleDataDay['items'];
  onEditEvent: (eventId: string) => void; // Callback for editing an event
  setConfirmationType: (type: ConfirmationDialogMode | null) => void;
  setDeleteId: (id: string) => void;
  onAddClick: () => void;
};

export const TbaSection = (props: DayToggleProps) => {
  const { day, onEditEvent, setConfirmationType, setDeleteId, onAddClick } = props;
  const { tq } = useTranslation('generalEventScheduleEditor');

  return (
    <DayGroup
      title={tq`Date To Be Announced`}
      onAddClick={onAddClick}
    >
      {day.map((event, index) => {
        const showDivider = index !== day.length - 1;

        return (
          <>
            <EventRow
              onEditClick={() => {
                onEditEvent(event.id);
              }}
              key={event.id}
              isPublic={true}
              title={event.name}
              subtitle={'TBA'}
              onDeleteClick={() => {
                setConfirmationType('delete');
                setDeleteId(event.id);
              }}
            ></EventRow>
            {showDivider && <Divider />}
          </>
        );
      })}
    </DayGroup>
  );
};
